import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * FE-282 Pass 12: redirect /invoices/ar/new → /invoices/new?kind=ar.
 * Direct URL pattern intuitive для пользователя (commonly tried), но реальный
 * route один — /invoices/new с query param. Без redirect показывался Not Found.
 */
export const Route = createFileRoute('/_auth/invoices/ar/new')({
  beforeLoad: () => {
    throw redirect({ to: '/invoices/new', search: { kind: 'ar' } as never });
  },
});
